import * as yup from "yup";
import { validationSchemas } from "./data";
export const paymentTypeSchema = yup.object().shape({
  name: validationSchemas.name,
  paymentType: validationSchemas.numberSelect,
});
